import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-events-card',
  templateUrl: './events-card.component.html',
  styleUrls: ['./events-card.component.scss']
})
export class EventsCardComponent implements OnInit {

  @Input('type') type: 'Curso' | 'Evento' = 'Curso';
  @Input('title') title: string;
  @Input('date') date: string;
  @Input('local') local: string;

  constructor() { }

  ngOnInit(): void {
  }

}
